<script setup lang="ts">
import type { NovaBoxChatBotButtonProps } from './NovaBoxChatBotButton.types'
import TabChatbotDefault from '@assets/images/bottom-tab-chatbot-default.svg?url'

withDefaults(defineProps<NovaBoxChatBotButtonProps>(), {
  loading: false,
})
</script>

<template>
  <button type="button" :class="['nova-chatbot-button', { loading }]">
    <img :src="TabChatbotDefault" alt="" />
    <NovaLoadingIndicator
      v-if="loading"
      :bg-bright="'light'"
      :overlay="true"
      class="loading-indicator"
    />
  </button>
</template>

<style scoped lang="scss">
.nova-chatbot-button {
  position: relative;
  display: none;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  font-size: 0;
  background-color: $color-secondary-blue-light-70;
  border-radius: 50%;
  box-shadow: 0 4px 4px 0 #00000026;
  @include mobile {
    width: 48px;
    height: 48px;
  }
  > img {
    @include mobile {
      width: 24px;
    }
  }
  &.loading {
    pointer-events: none;

    .icon {
      opacity: 0.2;
    }

    .label {
      opacity: 0.2;
    }
  }
}
</style>
